module.exports = __webpack_public_path__ + "images/addAdult_baadbd8.svg";